import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from '../lib/axios';
import { endpoints } from '../constants/endpoints';
import { useUserStore } from '../store/userStore';
import { User } from '../types/auth';
import { UserRole } from '../constants/roles';
import Layout from './Layout';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

export default function ProtectedRoute({
  children,
  requireSuperAdmin,
}: ProtectedRouteProps) {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const { user, setUser } = useUserStore();

  useEffect(() => {
    const validateToken = async () => {
      if (user) {
        setIsValid(true);
        setIsValidating(false);
        return;
      }

      try {
        const userData: User = await axios.get(endpoints.auth.me);
        setUser(userData);
        setIsValid(true);
      } catch {
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, [user, setUser]);

  if (isValidating) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperAdmin && user?.role !== UserRole.SUPERADMIN) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Layout>{children}</Layout>;
}
